import React, { useEffect, useRef, useState } from "react";
import {
	Button,
	CheckPicker,
	Checkbox,
	Input,
	InputGroup,
	Modal,
	Radio,
	RadioGroup,
	Tooltip,
	Whisper,
	SelectPicker,
	Notification,
	useToaster,
} from "rsuite";
import { connect, useDispatch, useSelector } from "react-redux";
import {
	getCostOptimizationData,
	getAllFiltersCostOptimization,
	updateCostOptimizationData,
} from "../../queries/apiQueries";
import SupplierTable from "./supplierTable";
import MaterialTable from "./materialTable";
import "./costOptimization.scss";
import CostGraph from "./costGraph";
import { FILTERDATA, TIMELINE, numberFormatter } from "../../utils";
import SearchIcon from "@rsuite/icons/Search";
import {  projectType } from "../constants";
import { appInsights } from "../router";
import MainHeader from "../../components/Layouts/MainHeader";
import ToggleSwitch from "../../components/common/ToggleSwitch";
import MainContent from "../../components/Layouts/MainContent";
import { Segmented } from "antd";
import FileDownloadIcon from "@rsuite/icons/FileDownload";
import { CSVLink } from "react-csv";
import { Loader } from "../../components/common/Loader";
import { getTimelineOptions } from "../../config/constants";

const csvHeaders = [
	{ label: "SKUL", key: "SKUl" },
	{ label: "Part Number", key: "partNumber" },
	{ label: "Region", key: "region" },
	{ label: "District", key: "district" },
	{ label: "Quantity", key: "quantity" },
	{ label: "Spend", key: "spend" },
	{ label: "Average ITS $/Unit", key: "avgITSPerUnit" },
	{ label: "SPA $/Unit", key: "spaPerUnit" },
	{ label: "Net Cost", key: "netcost" },
	{ label: "Target Cost", key: "targetcost" },
	{ label: "Opportunity", key: "opportunity" },
];

const csvHeadersRegional = [
	{ label: "SKUL", key: "SKUl" },
	{ label: "Part Number", key: "partNumber" },
	{ label: "Region", key: "region" },
	{ label: "District", key: "district" },
	{ label: "Quantity", key: "quantity" },
	{ label: "Spend", key: "spend" },
	{ label: "Average ITS $/Unit", key: "avgITSPerUnit" },
	{ label: "SPA $/Unit", key: "spaPerUnit" },
	{ label: "Net Cost", key: "netcost" },
	{ label: "Target Cost", key: "regionTargetCost" },
	{ label: "Opportunity", key: "regionOpportunity" },
];

const CostOptimization = (props: any) => {
	const timelineOptions=getTimelineOptions()
	const dispatch = useDispatch<any>();
	const toaster = useToaster();
	var isCleared = false;
	const exportFullRef = useRef(null);
	const exportFullRegionalRef = useRef(null);

	const allFilters = useSelector(
		(state: any) => state.CommonReducer.allFilters
	);

	const token = useSelector((state: any) => state.CommonReducer.token);

	const timeline = useSelector((state: any) => state.CommonReducer.timeline);

	const [optimizationData, setOptimizationData] = useState<any>(null);
	const [backUpData, setBackUpData] = useState<any>(null);

	const [filtersLoading, setFiltersLoading] = useState(true);
	const [isLoading, setIsLoading] = useState(true);
	const [isVisible, setIsVisible] = useState(false);
	const [isFilterVisible, setIsFilterVisible] = useState(false);
	const [exportHeader, setExportHeader] = useState<any>([]);
	const [exportHeaderRegional, setExportHeaderRegional] = useState<any>([]);
	const [isRightVisible, setIsRightVisible] = useState(false);

	const [exportData, setExportData] = useState<any>([]);
	const [exportSupplierData, setExportSupplierData] = useState<any>([]);
	const [exportDataRegional, setExportDataRegional] = useState<any>([]);
	const [page, setPage] = useState("national");
	const [supplierPageNumber, setSupplierPageNumber] = useState(1);
	const [materialPageNumber, setMaterialPageNumber] = useState(1);
	const [target, setTarget] = useState("national");
	const [selectedMaterial, setSelectedMaterial] = useState<any>(null);
	const [selectedRegions, setSelectedRegions] = useState<any>([]);
	const [updatedMaterials, setUpdatedMaterials] = useState<any>([]);
	const [saveButton, setSaveButton] = useState<any>(false);
	const [scatterData, setScatterData] = useState([]);
	const [summaryData, setSummaryData] = useState<any>({});
	const [summaryParams, setSummaryParams] = useState<{
		opportunity: number | string;
		targetCost: number | string;
		netCost: number | string;
		variance: number | string;
	}>({ opportunity: 0, targetCost: 0, netCost: 0, variance: 0 });
	const [alert, setAlert] = useState(false);

	const [selectedSupplier, setSelectedSupplier] = useState<any>(null);

	const [materialTargetCost, setMaterialTargetCost] = useState<null | number>(
		null
	);
	const [materialId, setMateriaId] = useState<any>(null);
	const didMount: any = useRef(false);
	const didClear: any = useRef(false);

	const [filterOptions, updateFilterOptions] = useState<any>({
		l1: new Array<{ l1: string }>(),
		l2: new Array<{ l2: string }>(),
		l3: new Array<{ l3: string }>(),
		l4: new Array<{ l4: string }>(),
		supplier: new Array<{ vendor: string }>(),
	});

	const [selectedProjectType, setSelectedProjectType] = useState(
		projectType.length && projectType[2].value
	);

	const [selectedFilters, setSelectedFilters] = useState<any>({
		...allFilters,
		l4: [],
	});

	// const [selectedL4Filters, setSelectedL4Filters] = useState<any>([]);

	const [regionTargetCosts, setRegionTargetCosts] =
		useState<null | Array<number>>(null);

	const [selectedRegionTargetCost, setSelectedRegionTargetCost] = useState<
		number | null
	>(null);

	const [errorMessage, setErrorMessage] = useState("");

	const [selectedTimeline, setSelectedTimeline] = useState(
		timeline ? timeline : getTimelineOptions()[0]?.value
	);

	/*   useEffect(() => {
      console.log("COST OPTIMIZATION", selectedFilters);
      // setSelectedFilters(selectedFilters);
      // getFilters();
      // getSupplierData();
    }, []); */

	useEffect(() => {
		if (token) {
			getSupplierData({
				vendor_name: selectedSupplier
					? [selectedSupplier]
					: [...selectedFilters?.supplier],
				material: [],
				l1: [...selectedFilters.l1],
				l2: [...selectedFilters.l2],
				l3: [...selectedFilters.l3],
				l4: selectedFilters.l4 ? [...selectedFilters.l4] : [],
				timeline: selectedTimeline,
				projectType: selectedProjectType,
				District: [],
				Region: [],
				grouping_level: ["master_vendor_name"],
				pageNumber: selectedSupplier
					? [materialPageNumber]
					: [supplierPageNumber],
				pageSize: [10],
				orderBy: ["adjustedNationalOpportunity"],
				order: ["Desc"],
				materialInfo: selectedSupplier ? true : false,
			});
			getFilters(
				{
					...selectedFilters,
					supplier: selectedSupplier
					? [selectedSupplier]
					: [...selectedFilters?.supplier],
				}
			);
		}
	}, [selectedSupplier, supplierPageNumber, materialPageNumber]);

	useEffect(() => {
		props.onTimelineChange(selectedTimeline);
		if (selectedTimeline && token) {
			getSupplierData({
				...selectedFilters,
				vendor_name: selectedSupplier
					? [selectedSupplier]
					: [...selectedFilters?.supplier],
				material: [],
				l1: selectedFilters.l1,
				l2: selectedFilters.l2,
				l3: selectedFilters.l3,
				l4: selectedFilters.l4,
				District: [],
				Region: [],
				grouping_level: ["master_vendor_name"],
				pageNumber: [1],
				pageSize: [10],
				orderBy: ["adjustedNationalOpportunity"],
				order: ["Desc"],
				materialInfo: selectedSupplier ? true : false,
			});
		}
	}, [selectedTimeline]);

	useEffect(() => {
		if (selectedProjectType && token) {
			getSupplierData({
				...selectedFilters,
				vendor_name: selectedSupplier
					? [selectedSupplier]
					: [...selectedFilters?.supplier],
				material: [],
				l1: selectedFilters.l1,
				l2: selectedFilters.l2,
				l3: selectedFilters.l3,
				l4: selectedFilters.l4,
				District: [],
				Region: [],
				grouping_level: ["master_vendor_name"],
				pageNumber: [1],
				pageSize: [10],
				orderBy: ["adjustedNationalOpportunity"],
				order: ["Desc"],
				materialInfo: selectedSupplier ? true : false,
			});
		}
	}, [selectedProjectType]);

	const getExportData = () => {
		getSupplierData({
			vendor_name: selectedSupplier
				? [selectedSupplier]
				: [...selectedFilters?.supplier],
			material: [],
			l1: [...selectedFilters.l1],
			l2: [...selectedFilters.l2],
			l3: [...selectedFilters.l3],
			timeline: selectedTimeline,
			projectType: selectedProjectType,
			District: [],
			Region: [],
			grouping_level: ["master_vendor_name"],
			pageNumber: selectedSupplier
				? [materialPageNumber]
				: [supplierPageNumber],
			pageSize: [10],
			orderBy: ["adjustedNationalOpportunity"],
			order: ["Desc"],
			materialInfo: selectedSupplier ? true : false,
			isExport: true,
		});
	};

	const getExportSupplierData = () => {
		getSupplierData({
			vendor_name: [],
			material: [],
			l1: [...selectedFilters.l1],
			l2: [...selectedFilters.l2],
			l3: [...selectedFilters.l3],
			l4: selectedFilters.l4 ? [...selectedFilters.l4] : [],
			timeline: selectedTimeline,
			projectType: selectedProjectType,
			District: [],
			Region: [],
			grouping_level: ["master_vendor_name"],
			pageNumber: selectedSupplier
				? [materialPageNumber]
				: [supplierPageNumber],
			pageSize: [10],
			orderBy: ["adjustedNationalOpportunity"],
			order: ["Desc"],
			materialInfo: selectedSupplier ? true : false,
			isExport: true,
		});
	};

	const getSupplierData = async (payload: any) => {
		if (!payload?.isExport) {
			setIsLoading(true);
		}
		if (payload?.isExport) {
			toaster.push(message, { placement: "topCenter" });
		}
		payload = { ...selectedFilters, ...payload };
		// payload.l4=selectedL4Filters
		// if (payload.vendor) {
		payload.vendor_name = payload.supplier;
		payload.timeline = selectedTimeline;
		payload.projectType = selectedProjectType;
		// delete payload.vendor;
		// }
		if (selectedSupplier?.length > 0) {
			payload.materialInfo = true;
			payload.vendor_name = [selectedSupplier];
			setSelectedMaterial(null);
		}
		let res = await dispatch(getCostOptimizationData(payload));
		if (res?.error) {
			setErrorMessage(res.message);
		} else {
			setErrorMessage("");
			if (!payload?.isExport) {
				if (selectedSupplier?.length > 0) {
					setSummaryData(res?.scatterData);
				}
				setOptimizationData(res);
				if (!backUpData && selectedSupplier) {
					setBackUpData(JSON.parse(JSON.stringify(res)));
				}
			}
			// prepareExportHeader(res?.data?.materials);
			if (payload?.isExport && selectedSupplier) {
				prepareExportData(res?.data?.materials);
			}
			if (payload?.isExport && !selectedSupplier) {
				res.data.map((item: any) => {
					item.LastYear_Cost = `$${item.LastYear_Cost.toFixed(0)}`;
					item.adjustedNationalOpportunity = `$${item.adjustedNationalOpportunity.toFixed(
						0
					)}`;
					item.adjustedRegionalOpportunity = `$${item.adjustedRegionalOpportunity.toFixed(
						0
					)}`;
				});

				setExportSupplierData(res?.data);
			}
		}
		// setTimeout(() => {
		setIsLoading(false);
		// }, 2000);
	};

	const prepareExportData = (data: any) => {
		let finalData: any = [];
		data.forEach((val: any) => {
			let obj: any = {};

			val?.Region.forEach((val1: any) => {
				val1?.Districts.forEach((val2: any) => {
					obj = {
						SKUl: val?.material,
						partNumber: val?.MAN_PART_NO,
						region: val1?.Region,
						spend: val2?.LastYear_Cost,
						quantity: val2?.LastYear_Qty,
						district: val2?.District,
						netcost: val2?.costPerUnit,
						targetcost: val2?.adjustedNationalTargetCost,
						regionTargetCost: val2?.adjustedRegionalTargetCost,
						opportunity: val2?.adjustedNationalOpportunity,
						regionOpportunity: val2?.adjustedRegionalOpportunity,
						avgITSPerUnit:
							val2?.LastYear_initialCost / val2?.LastYear_Qty,
						spaPerUnit:
							val2?.LastYear_spaAmount / val2?.LastYear_Qty,
					};

					finalData.push(obj);
				});
			});
		});

		finalData.map((item: any) => {
			item.spend = `$${item.spend.toFixed(0)}`;
			item.opportunity = `$${item.opportunity.toFixed(0)}`;
			item.regionOpportunity = `$${item.regionOpportunity.toFixed(0)}`;
			item.netcost = `${item.netcost.toFixed(2)}`;
			item.targetcost = `${item.targetcost.toFixed(2)}`;
			item.regionTargetCost = `${item.regionTargetCost.toFixed(2)}`;
			item.avgITSPerUnit = `${item.avgITSPerUnit.toFixed(2)}`;
			item.spaPerUnit = `${item.spaPerUnit.toFixed(2)}`;
		});

		setExportData(finalData);
		setExportDataRegional(finalData);
	};

	const searchByMaterial = () => {
		console.log(materialId,"mater")
		let payload = {
			vendor_name: [selectedSupplier],
			material:materialId!==''? ["0000000000" + materialId]:[],
			l1: [],
			l2: [],
			l3: [],
			l4: [],
			timeline: selectedTimeline,
			projectType: selectedProjectType,
			District: [],
			Region: [],
			grouping_level: ["master_vendor_name"],
			pageNumber: [1],
			pageSize: [10],
			orderBy: ["adjustedNationalOpportunity"],
			order: ["Desc"],
			materialInfo: true,
		};

		getSupplierData(payload);
	};

	/* Filters api call */
	const getFilters = async (
		payload: any = {},
		currentFilter: any = "all",
		fo: any = null
	) => {
		setFiltersLoading(true);
		payload.timeline = selectedTimeline;
		if (payload.supplier) {
			payload.vendor_name = payload.supplier;
			// delete payload.supplier;
		}
		let res = await dispatch(getAllFiltersCostOptimization(payload));
		if (fo) {
			fo.supplier = fo.suppliers;
			delete fo.suppliers;
			if (currentFilter === "l1") {
				updateFilterOptions({
					...fo,
					l2: [...res.l2],
					l3: [...res.l3],
					l4: [...res.l4],
					supplier: [...res.suppliers],
				});
			} else if (currentFilter === "l2") {
				updateFilterOptions({
					...fo,
					l3: [...res.l3],
					l4: [...res.l4],
					supplier: [...res.suppliers],
				});
			} else if (currentFilter === "l3") {
				updateFilterOptions({
					...fo,
					l4: [...res.l4],
					supplier: [...res.suppliers],
				});
			} else if (currentFilter === "l4") {
				updateFilterOptions({ ...fo, supplier: [...res.suppliers] });
			} else if (currentFilter === "supplier") {
				updateFilterOptions({ ...fo });
			} else {
				updateFilterOptions({
					l1: res.l1,
					l2: res.l2,
					l3: res.l3,
					l4: res.l4,
					supplier: res.suppliers,
				});
			}
		} else {
			if (currentFilter === "l1") {
				updateFilterOptions({
					...filterOptions,
					l2: [...res.l2],
					l3: [...res.l3],
					l4: [...res.l4],
					supplier: [...res.suppliers],
				});
			} else if (currentFilter === "l2") {
				updateFilterOptions({
					...filterOptions,
					l3: [...res.l3],
					l4: [...res.l4],
					supplier: [...res.suppliers],
				});
			} else if (currentFilter === "l3") {
				updateFilterOptions({
					...filterOptions,
					l4: [...res.l4],
					supplier: [...res.suppliers],
				});
			} else if (currentFilter === "l4") {
				updateFilterOptions({
					...filterOptions,
					supplier: [...res.suppliers],
				});
			} else if (currentFilter === "supplier") {
				updateFilterOptions({ ...filterOptions });
			} else {
				updateFilterOptions({
					l1: res.l1,
					l2: res.l2,
					l3: res.l3,
					l4: res.l4,
					supplier: res.suppliers,
				});
			}
		}

		// setIsLoading(false);
		setFiltersLoading(false);
		return res;
	};

	/* Updating filter selection state  */
	const handleFilterUpdate = (value: any, filter: string) => {
		console.log(value, filter);
		if (isCleared) {
			isCleared = false;
			return;
		}
		let x: string = filter;
		if (value === "all") {
			if (filterOptions?.[x].length === selectedFilters?.[x].length) {
				setSelectedFilters({ ...selectedFilters, [x]: [] });
			} else {
				if (x == "supplier") {
					setSelectedFilters({
						...selectedFilters,
						[x]: [
							...filterOptions?.[x].map(
								(option: any) => option.vendor
							),
						],
					});
				} else {
					setSelectedFilters({
						...selectedFilters,
						[x]: [
							...filterOptions?.[x].map(
								(option: any) => option?.[x]
							),
						],
					});
				}
			}
		} else {
			setSelectedFilters({ ...selectedFilters, [x]: [...value] });
		}
	};

	/* Updating filter options based on selection (api) */
	const handleClose = (filter: string) => {
		console.log(selectedFilters);
		setMateriaId(null);
		if (filter === "l1") {
			setSelectedFilters({
				...selectedFilters,
				l2: [],
				l3: [],
				l4: [],
				supplier: [],
			});
			getFilters(
				{ ...selectedFilters, l2: [], l3: [], l4: [], supplier: [] },
				"l1"
			);
			getSupplierData({
				vendor_name: selectedSupplier
					? [selectedSupplier]
					: [...selectedFilters?.supplier],
				material: [],
				l1: selectedFilters.l1,
				District: [],
				Region: [],
				grouping_level: ["master_vendor_name"],
				pageNumber: [1],
				pageSize: [10],
				orderBy: ["adjustedNationalOpportunity"],
				order: ["Desc"],
				materialInfo: selectedSupplier ? true : false,
			});
		}
		if (filter === "l2") {
			setSelectedFilters({
				...selectedFilters,
				l3: [],
				l4: [],
				supplier: [],
			});
			getFilters(
				{ ...selectedFilters, l3: [], l4: [], supplier: [] },
				"l2"
			);
			getSupplierData({
				...selectedFilters,
				vendor_name: selectedSupplier
					? [selectedSupplier]
					: [...selectedFilters?.supplier],
				material: [],
				l1: selectedFilters.l1,
				l2: selectedFilters.l2,
				District: [],
				Region: [],
				grouping_level: ["master_vendor_name"],
				pageNumber: [1],
				pageSize: [10],
				orderBy: ["adjustedNationalOpportunity"],
				order: ["Desc"],
				materialInfo: selectedSupplier ? true : false,
			});
		}
		if (filter === "l3") {
			setSelectedFilters({ ...selectedFilters, l4: [], supplier: [] });
			getFilters({ ...selectedFilters, l4: [], supplier: [] }, "l3");
			getSupplierData({
				...selectedFilters,
				vendor_name: selectedSupplier
					? [selectedSupplier]
					: [...selectedFilters?.supplier],
				material: [],
				l1: selectedFilters.l1,
				l2: selectedFilters.l2,
				l3: selectedFilters.l3,
				District: [],
				Region: [],
				grouping_level: ["master_vendor_name"],
				pageNumber: [1],
				pageSize: [10],
				orderBy: ["adjustedNationalOpportunity"],
				order: ["Desc"],
				materialInfo: selectedSupplier ? true : false,
			});
		}
		if (filter === "l4") {
			setSelectedFilters({ ...selectedFilters, supplier: [] });
			getFilters({ ...selectedFilters, supplier: [] }, "l4");
			getSupplierData({
				...selectedFilters,
				vendor_name: selectedSupplier
					? [selectedSupplier]
					: [...selectedFilters?.supplier],
				material: [],
				l1: selectedFilters.l1,
				l2: selectedFilters.l2,
				l3: selectedFilters.l3,
				l4: selectedFilters.l4,
				District: [],
				Region: [],
				grouping_level: ["master_vendor_name"],
				pageNumber: [1],
				pageSize: [10],
				orderBy: ["adjustedNationalOpportunity"],
				order: ["Desc"],
				materialInfo: selectedSupplier ? true : false,
			});
		}
		if (filter === "supplier") {
			getFilters({ ...selectedFilters }, "supplier");
			getSupplierData({
				...selectedFilters,
				vendor_name: selectedSupplier
					? [selectedSupplier]
					: [...selectedFilters?.supplier],
				material: [],
				District: [],
				Region: [],
				grouping_level: ["master_vendor_name"],
				pageNumber: [1],
				pageSize: [10],
				orderBy: ["adjustedNationalOpportunity"],
				order: ["Desc"],
				materialInfo: selectedSupplier ? true : false,
			});
		}
	};

	const handleClear = (filter: string) => {
		isCleared = true;
		didClear.current = true;
		if (filter === "district") {
			setSelectedFilters({
				district: [],
				l1: [],
				l2: [],
				l3: [],
				supplier: [],
			});

			getFilters(
				{ district: [], l1: [], l2: [], l3: [], supplier: [] },
				"district"
			);
		} else if (filter === "l1") {
			setSelectedFilters({
				...selectedFilters,
				l1: [],
				l2: [],
				l3: [],
				l4: [],
				supplier: [],
			});
			getFilters(
				{
					...selectedFilters,
					l1: [],
					l2: [],
					l3: [],
					l4: [],
					supplier: [],
				},
				"l1"
			);
		} else if (filter === "l2") {
			setSelectedFilters({
				...selectedFilters,
				l2: [],
				l3: [],
				l4: [],
				supplier: [],
			});
			getFilters(
				{ ...selectedFilters, l2: [], l3: [], l4: [], supplier: [] },
				"l2"
			);
		} else if (filter === "l3") {
			// handleClose('l2');
			setSelectedFilters({
				...selectedFilters,
				l3: [],
				l4: [],
				supplier: [],
			});
			getFilters(
				{ ...selectedFilters, l3: [], l4: [], supplier: [] },
				"l3"
			);
		} else if (filter === "l4") {
			setSelectedFilters({ ...selectedFilters, l4: [] });
			getFilters({ ...selectedFilters, l4: [] }, "l4");
		} else if (filter === "supplier") {
			setSelectedFilters({ ...selectedFilters, supplier: [] });
			getFilters({ ...selectedFilters, supplier: [] }, "supplier");
		}
		if (filter == "supplier") {
			getSupplierData({
				vendor_name: selectedSupplier
					? [selectedSupplier]
					: [...selectedFilters?.supplier],
				supplier:
					filter == "supplier" ? [] : [...selectedFilters.supplier],
				material: [],
				l1: [],
				District: [],
				Region: [],
				grouping_level: ["master_vendor_name"],
				pageNumber: [1],
				pageSize: [10],
				orderBy: ["adjustedNationalOpportunity"],
				order: ["Desc"],
				materialInfo: selectedSupplier ? true : false,
			});
		}
	};

	useEffect(() => {
		if (token) {
			if (didClear?.current) {
				getSupplierData({
					vendor_name: selectedSupplier
						? [selectedSupplier]
						: [...selectedFilters?.supplier],
					supplier: [...selectedFilters.supplier],
					material: [],
					District: [],
					Region: [],
					grouping_level: ["master_vendor_name"],
					pageNumber: [1],
					pageSize: [10],
					orderBy: ["adjustedNationalOpportunity"],
					order: ["Desc"],
					materialInfo: selectedSupplier ? true : false,
				});
				didClear.current = false;
			}
		}
	}, [selectedFilters]);

	// useEffect(()=>{
	//   if(selectedL4Filters){
	//     getSupplierData({
	//       vendor_name: selectedSupplier
	//         ? [selectedSupplier]
	//         : [...selectedFilters?.supplier],
	//       supplier: [...selectedFilters.supplier],
	//       material: [],
	//       District: [],
	//       Region: [],
	//       grouping_level: ["master_vendor_name"],
	//       pageNumber: [1],
	//       pageSize: [10],
	//       orderBy: ["adjustedNationalOpportunity"],
	//       order: ["Desc"],
	//       materialInfo: selectedSupplier ? true : false,
	//     });
	//   }
	// },[selectedL4Filters])

	useEffect(() => {
		if (didClear?.current) {
			getSupplierData({
				vendor_name: selectedSupplier
					? [selectedSupplier]
					: [...selectedFilters?.supplier],
				supplier: [...selectedFilters.supplier],
				material: [],
				District: [],
				Region: [],
				grouping_level: ["master_vendor_name"],
				pageNumber: [1],
				pageSize: [10],
				orderBy: ["adjustedNationalOpportunity"],
				order: ["Desc"],
				materialInfo: selectedSupplier ? true : false,
			});
			didClear.current = false;
		}
	}, [selectedFilters]);

	useEffect(() => {
		if (target == "regional") {
			setMaterialTargetCost(null);
		} else {
			if (selectedMaterial) {
				setMaterialTargetCost(
					optimizationData.data.materials.filter(
						(data: any) => data.material == selectedMaterial
					)[0].adjustedNationalTargetCost
				);
			}
		}
	}, [target]);

	useEffect(() => {
		// setTarget("national");
		if (selectedMaterial) {
			setMaterialTargetCost(
				optimizationData.data.materials.filter(
					(data: any) => data.material == selectedMaterial
				)[0].adjustedNationalTargetCost
			);
			let filteredData = summaryData.data.filter(
				(data: any) => data.material == selectedMaterial
			);
			// setScatterData(
			//   filteredData.map((i: any) => {
			//     i.costPerUnit = i.LastYear_Cost / i.LastYear_Qty;

			//     return i;
			//   })
			// );
			setScatterData(filteredData);
		}
	}, [selectedMaterial]);

	useEffect(() => {
		let temp = summaryParams;
		if (selectedMaterial && optimizationData?.data?.materials) {
			let filteredMaterial = optimizationData?.data?.materials.filter(
				(data: any) => data.material == selectedMaterial
			)[0];
			if (target == "national") {
				temp.opportunity = numberFormatter(
					filteredMaterial?.adjustedNationalOpportunity,
					0
				);
				temp.targetCost = numberFormatter(
					filteredMaterial?.adjustedNationalTargetCost,
					2
				);
				temp.variance = numberFormatter(
					summaryData.nationalVariance[selectedMaterial] * 100,
					2
				);
				temp.netCost = numberFormatter(
					filteredMaterial?.LastYear_Cost,
					0
				);
				if (selectedRegions.length > 0) {
					temp.netCost = 0;
					temp.opportunity = 0;
					let filteredRegions = filteredMaterial.Region.filter(
						(d: any) => selectedRegions.includes(d.Region)
					);
					const { spend, opportunity } = filteredRegions.reduce(
						(initial: any, acc: any) => {
							return {
								spend: initial.spend + acc.LastYear_Cost,
								opportunity:
									initial.opportunity +
									acc.adjustedNationalOpportunity,
							};
						},
						{ spend: 0, opportunity: 0 }
					);
					temp.netCost = numberFormatter(spend, 0);
					temp.opportunity = numberFormatter(opportunity, 0);
				}
			} else {
				setSelectedRegionTargetCost(null);
				temp.variance = "Region Specific";
				temp.targetCost = "Region Specific";
				temp.netCost = numberFormatter(
					filteredMaterial?.LastYear_Cost,
					0
				);
				temp.opportunity = numberFormatter(
					filteredMaterial?.adjustedRegionalOpportunity,
					0
				);
				setRegionTargetCosts(
					filteredMaterial?.Region?.map((d: any) => {
						return {
							region: d.Region,
							cost: d.adjustedRegionalTargetCost,
						};
					})
				);

				if (selectedRegions.length > 0) {
					temp.netCost = 0;
					temp.opportunity = 0;
					let filteredRegions = filteredMaterial.Region.filter(
						(d: any) => selectedRegions.includes(d.Region)
					);
					const { spend, opportunity } = filteredRegions.reduce(
						(initial: any, acc: any) => {
							return {
								spend: initial.spend + acc.LastYear_Cost,
								opportunity:
									initial.opportunity +
									acc.adjustedRegionalOpportunity,
							};
						},
						{ spend: 0, opportunity: 0 }
					);
					temp.netCost = numberFormatter(spend, 0);
					temp.opportunity = numberFormatter(opportunity, 0);

					if (selectedRegions.length == 1) {
						setSelectedRegionTargetCost(
							filteredRegions[0].adjustedRegionalTargetCost
						);
						temp.targetCost = numberFormatter(
							filteredRegions[0].adjustedRegionalTargetCost,
							2
						);
						temp.variance = numberFormatter(
							optimizationData.scatterData.Region[
								selectedMaterial
							][selectedRegions[0]] * 100,
							2
						);
					} else {
						temp.targetCost = "Region Specific";
					}
				}
			}
			setSummaryParams({ ...temp });
		}
	}, [selectedMaterial, selectedRegions, target, optimizationData]);

	useEffect(() => {
		appInsights.trackPageView({
			name: `Navigate to Cost Optimization by ${localStorage.getItem(
				"name"
			)}`,
		});
		if (token) {
			if (!didMount.current) {
				getFilters().then((options: any) => {
					if (selectedFilters.supplier.length > 0) {
						getFilters({ ...selectedFilters }, "supplier", options);
						// getSupplierData(selectedFilters);
					} else if (
						selectedFilters.l4 &&
						selectedFilters.l4.length > 0
					) {
						getFilters(selectedFilters, "l4", options);
						// getSupplierData(selectedFilters);
					} else if (selectedFilters.l3.length > 0) {
						getFilters(selectedFilters, "l3", options);
						// getSupplierData(selectedFilters);
					} else if (selectedFilters.l2.length > 0) {
						getFilters(selectedFilters, "l2", options);
						// getSupplierData(selectedFilters);
					} else if (selectedFilters.l1.length > 0) {
						getFilters(selectedFilters, "l1", options);
						// getSupplierData(selectedFilters);
					}
				});
				getSupplierData({
					// vendor_name: [],
					material: [],
					// l1: [],
					// l2: [],
					// l3: [],
					District: [],
					Region: [],
					grouping_level: ["master_vendor_name"],
					pageNumber: [1],
					pageSize: [10],
					orderBy: ["adjustedNationalOpportunity"],
					order: ["Desc"],
					materialInfo: false,
				});
				didMount.current = true;
			} else {
				props.onFilterChange(selectedFilters);
			}
		}
	}, [token, selectedFilters]);

	const updateOptmizationData = (
		updatedMaterialData: any,
		materialNumber: any
	) => {
		let res = optimizationData;
		res.data.materials.map((item: any, index: any) => {
			if (item.material === materialNumber) {
				res.data.materials[index] = updatedMaterialData;
			}
		});
		setOptimizationData({ ...res });
	};
	const handleAlertClose = () => setAlert(false);

	const handleAlertConfirmClick = () => {
		setSelectedSupplier(null);
		setSelectedMaterial(null);
		getSupplierData({
			vendor_name: [],
			material: [],
			l1: [],
			l2: [],
			l3: [],
			l4: [],
			District: [],
			timeline: selectedTimeline,
			projectType: selectedProjectType,
			Region: [],
			grouping_level: ["master_vendor_name"],
			pageNumber: [1],
			pageSize: [10],
			orderBy: ["adjustedNationalOpportunity"],
			order: ["Desc"],
			materialInfo: false,
		});
		setSaveButton(false);
		setAlert(false);
		setMateriaId(null);
	};

	const handleSave = async () => {
		setIsLoading(true);
		let materialObj: any = [];
		materialObj =
			optimizationData &&
			optimizationData.data?.materials.filter((item: any, index: any) => {
				return updatedMaterials.includes(item.material);
			});

		let res = await dispatch(updateCostOptimizationData(materialObj));
		setSaveButton(false);
		setIsLoading(false);
	};

	const handleReset = () => {
		setOptimizationData(JSON.parse(JSON.stringify(backUpData)));
		setSaveButton(false);
	};

	/* on changing timeline */
	const timelineHandler = (e: any) => {
		setSelectedTimeline(e === null ? "All" : e);
	};

	/* on changing project type */
	const projectTypeHandler = (e: any) => {
		setSelectedProjectType(e === null ? "All" : e);
	};
	const handleToggleChange = (e: { target: { checked: any } }) => {
		setTarget(e.target.checked ? "regional" : "national");
	};

	const removeLeadingZero = (n: any) => {
		let newStr = n.replace(/^0+/, "");
		return newStr;
	};

	return isLoading ? (
		<Loader />
	) : (
		<>
			<Modal
				backdrop={true}
				role="alertdialog"
				open={alert}
				onClose={handleAlertClose}
				size="xs"
			>
				<Modal.Body>
					Any unsaved changes will be lost. Are you sure, you want to
					continue?
				</Modal.Body>
				<Modal.Footer>
					<Button
						onClick={handleAlertConfirmClick}
						className="modal-yes-btn"
					>
						Yes, Continue
					</Button>
					<Button
						onClick={handleAlertClose}
						className="modal-close-btn"
					>
						Close
					</Button>
				</Modal.Footer>
			</Modal>
			<div className="optimization-container w-full">
				<MainHeader
					onVisibilityChange={setIsVisible}
					isRightVisible={isRightVisible}
					setIsRightVisible={setIsRightVisible}
					topContent={
						<>
							{/* Top Row: Heading (left) and Breadcrumbs (right) */}
							<div className="flex justify-between items-center w-full">
								{/* Heading */}
								<div className="text-left pageline  min-w-0">
									<span className="pagelinestart truncate">
										Sourcing & Strategic Supplier
										Negotiations
									</span>
									<span className="pagelineslash">/</span>
									<span className="pagelinesub truncate">
										Cost Optimization
									</span>
								</div>

								{selectedSupplier && (
									<div className="flex items-center gap-1 flex-1 min-w-0 justify-end ml-4">
										<span
											className={`${
												selectedSupplier
													? "breadCrumSel"
													: "breadCrum"
											} truncate `}
											onClick={() => {
												if (selectedSupplier) {
													if (saveButton) {
														setAlert(true);
													} else {
														setSelectedSupplier(
															null
														);
														setMaterialPageNumber(
															1
														);
														setSupplierPageNumber(
															1
														);
														setSelectedMaterial(
															null
														);
														setMateriaId(null);
														setSaveButton(false);
														setExportData([]);
														setExportDataRegional(
															[]
														);
													}
												}
											}}
										>
											SUPPLIER
										</span>
									</div>
								)}

								{selectedSupplier && (
									<span
										className={`${
											selectedMaterial
												? "breadCrumSel"
												: "breadCrum"
										} truncate `}
										onClick={() => {
											if (selectedMaterial) {
												setSelectedMaterial(null);
												setMateriaId(null);
											}
										}}
									>{`> ${selectedSupplier}`}</span>
								)}
								{selectedMaterial && (
									<span className="text-[black] textNormal flex-nowrap truncate">{`> ${removeLeadingZero(selectedMaterial)}`}</span>
								)}
							</div>

							{/* View By Segment */}
							<div className="execution-level-wrapper">
								<div className="execution-level-title">
									View By
								</div>
								<Segmented
									options={[
										{
											label: "National Target",
											value: "national",
										},
										{
											label: "Regional Target",
											value: "regional",
										},
									]}
									value={target}
									onChange={(value) => setTarget(value)}
								/>
							</div>
						</>
					}
					bottomContent={
						<>
							<div className="sub-heading-text font-bold flex flex-col items-start">
								<span className="filterHead ">Timeline</span>
								<SelectPicker
									data={
										timelineOptions.length
											? timelineOptions
											: []
									}
									placeholder="All"
									
									value={selectedTimeline}
									defaultValue={
										timelineOptions.length
											? timelineOptions[0].value
											: ""
									}
									menuClassName="text-[0.85em]"
									onChange={timelineHandler}
									cleanable={false}
								/>
							</div>
							{Object.keys(filterOptions).length > 0 &&
								["l1", "l2", "l3", "supplier"].map(
									(filterEntity) => (
										<div
											key={filterEntity}
											className="sub-heading-text font-bold flex flex-col items-start"
										>
											<span className="filterHead ">
												{filterEntity}
											</span>
											<CheckPicker
												data={
													filterOptions[filterEntity]
														?.length
														? filterOptions[
																filterEntity
														  ]
														: []
												}
												placeholder="All"
												
												labelKey={
													filterEntity === "supplier"
														? "vendor"
														: filterEntity
												}
												valueKey={
													filterEntity === "supplier"
														? "vendor"
														: filterEntity
												}
												value={
													selectedFilters[
														filterEntity
													] || []
												}
												onClose={() =>
													handleClose(filterEntity)
												}
												onClean={() =>
													handleClear(filterEntity)
												}
												onChange={(value) =>
													handleFilterUpdate(
														value,
														filterEntity
													)
												}
												menuClassName="text-[0.85em]"
												loading={filtersLoading}
												style={{ width: "100%" }}
											/>
										</div>
									)
								)}
							<div className="sub-heading-text font-bold flex flex-col items-start">
								<span className="filterHead ">
									Project Type
								</span>
								<SelectPicker
									data={projectType.length ? projectType : []}
									placeholder="All"
									
									value={selectedProjectType}
									defaultValue={
										projectType.length
											? projectType[0].value
											: ""
									}
									menuClassName="text-[0.85em]"
									onChange={projectTypeHandler}
									cleanable={false}
								/>
							</div>
						</>
					}
				></MainHeader>
				<MainContent isVisible={isVisible} fullHeight={true}>
					<div className="flex flex-col h-[100%] justify-center">
						<div className={`chart-flex ${"h-[100%]"}`}>
							<div className="suppliers">
								<div className="common-table-content w-[100%]">
									{selectedSupplier ? (
										<div className="common-table-header-row">
											<div className="flex flex-row w-full justify-between gap-[1vw] ">
												{/* Left side: Back button and other controls */}
												<div className="flex flex-row items-center gap-[1vh]">
													{/* Material Number Search */}
													<span className="font-bold textNormal text-black">
														Material No.
													</span>
													<Whisper
														placement="bottom"
														speaker={
															<Tooltip>
																Please enter 8
																digit material
																number
															</Tooltip>
														}
													>
														<input
															type="text"
															maxLength={8}
															minLength={8}
															className="material-number-search w-[10vw] h-[1.8rem]"
															onInput={(
																e: any
															) => {
																return (e.target.value =
																	e.target.value.replace(
																		/[^\d]/g,
																		""
																	));
															}}
															value={
																materialId
																	? materialId
																	: ""
															}
															onChange={(e) =>
																setMateriaId(
																	e.target
																		.value
																)
															}
														/>
													</Whisper>
													<Button
														className="savingButton"
														onClick={
															searchByMaterial
														}
													>
														Search
													</Button>
												</div>

												<div className="flex flex-row items-center">
													<CheckPicker
														className="customwhite l4-dropdown"
														data={
															filterOptions["l4"]
																.length
																? filterOptions[
																		"l4"
																  ]
																: []
														}
														placeholder="L4"
														labelKey={"l4"}
														valueKey={"l4"}
														value={
															selectedFilters[
																"l4"
															]
																? selectedFilters[
																		"l4"
																  ]
																: []
														}
														onClose={() =>
															handleClose("l4")
														}
														onClean={() =>
															handleClear("l4")
														}
														onChange={(value) =>
															handleFilterUpdate(
																value,
																"l4"
															)
														}
														loading={filtersLoading}
														renderExtraFooter={() => (
															<div>
																<Checkbox
																	indeterminate={
																		selectedFilters[
																			"l4"
																		]
																			.length >
																			0 &&
																		selectedFilters[
																			"l4"
																		]
																			.length <
																			filterOptions[
																				"l4"
																			]
																				.length
																	}
																	checked={
																		selectedFilters[
																			"l4"
																		]
																			.length ===
																		filterOptions[
																			"l4"
																		].length
																	}
																	onChange={() =>
																		handleFilterUpdate(
																			"all",
																			"l4"
																		)
																	}
																>
																	Check all
																</Checkbox>
															</div>
														)}
													/>
													<div className="buttonWrapper">
														<Button
															className="bg-transparent hover:bg-transparent"
															onClick={
																getExportData
															}
														>
															<FileDownloadIcon
																color="black"
																className="text-fsre16"
															/>
														</Button>
														<CSVLink
															ref={exportFullRef}
															data={exportData}
															headers={csvHeaders}
															filename="costOptimisation.csv"
															className="hidden"
															target="_blank"
														/>
														<CSVLink
															ref={
																exportFullRegionalRef
															}
															data={
																exportDataRegional
															}
															headers={
																csvHeadersRegional
															}
															filename="costOptimisationRegional.csv"
															className="hidden"
															target="_blank"
														/>
													</div>
												</div>
											</div>
										</div>
									) : (
										""
									)}

									{errorMessage?.length > 0 ? (
										<div className="flex justify-center items-center h-full text-mainGreen">
											{errorMessage}
										</div>
									) : !selectedSupplier ? (
										optimizationData?.data && (
											<SupplierTable
												isVisible={isVisible}
												data={optimizationData?.data}
												count={optimizationData?.count}
												totalOpp={
													optimizationData?.totalOpp
												}
												getExportSupplierData={
													getExportSupplierData
												}
												exportSupplierData={
													exportSupplierData
												}
												target={target}
												updateSupplier={(
													supplier: any
												) => {
													if (
														supplier !=
														selectedSupplier
													) {
														setSelectedSupplier(
															supplier
														);
													}
													setSelectedMaterial(null);
													setSelectedRegions([]);
												}}
												updatePageNumber={(
													page: any
												) => {
													setSupplierPageNumber(page);
												}}
												pageNumber={supplierPageNumber}
											/>
										)
									) : (
										optimizationData?.data?.materials && (
											<MaterialTable
												isVisible={isVisible}
												data={optimizationData}
												exportData={exportData}
												exportDataRegional={
													exportDataRegional
												}
												count={
													optimizationData?.data
														?.materialCount
												}
												totalOpp={
													optimizationData?.totalOpp
												}
												selectedMaterial={
													selectedMaterial
												}
												getExportData={getExportData}
												updateSelectedMaterial={(
													value: any
												) => {
													setSelectedMaterial(value);
												}}
												selectedRegions={
													selectedRegions
												}
												updateSelectedRegions={(
													value: any
												) => {
													setSelectedRegions(value);
												}}
												updatePageNumber={(
													page: any
												) => {
													setMaterialPageNumber(page);
												}}
												handleChange={(
													updatedMaterialData: any,
													materialNumber: any
												) => {
													updateOptmizationData(
														updatedMaterialData,
														materialNumber
													);
												}}
												updateEditedtedMaterials={(
													item: any
												) => {
													setUpdatedMaterials(item);
												}}
												updatedMaterials={
													updatedMaterials
												}
												updateSaveButton={(
													item: any
												) => {
													setSaveButton(item);
												}}
												saveButton={saveButton}
												target={target}
												pageNumber={materialPageNumber}
												handleSave={() => {
													handleSave();
												}}
												handleReset={() => {
													handleReset();
												}}
											/>
										)
									)}
								</div>
							</div>

							<div
								className="chart-container"
								style={
									!selectedMaterial
										? { justifyContent: "center" }
										: {}
								}
							>
								{selectedMaterial ? (
									<>
										<div className="summary costOptimizationSummary flex gap-2 ">
											<div className="card">
												<span className="header">
													{target} Target Cost
													($/Unit)
												</span>
												<div className="bottom">
													{summaryParams.targetCost}
												</div>
											</div>
											<div className="card">
												<span className="header">
													{target} Cost Variance (%)
												</span>
												<div className="bottom">
													{summaryParams.variance}
												</div>
											</div>
											<div className="card">
												<span className="header">
													{new Date().getFullYear() -
														1}{" "}
													Net Spend ($)
												</span>
												<div className="bottom">
													{summaryParams.netCost}
												</div>
											</div>
											<div className="card">
												<span className="header">
													Opportunity ($)
												</span>
												<div className="bottom">
													{summaryParams.opportunity}
												</div>
											</div>
										</div>

										<div className="chart">
											<div className="headSpace">
												<div className="headContent">
													Target Cost
												</div>
											</div>
											<CostGraph
												data={scatterData}
												region={selectedRegions}
												refLine={
													target == "national"
														? materialTargetCost
														: selectedRegionTargetCost
												}
												regionalTargetCosts={
													target == "national"
														? null
														: regionTargetCosts
												}
												target={target}
											/>
										</div>
									</>
								) : (
									<span className="flex justify-start items-center text-black text-[2.5vh] italic font-normal">
										{errorMessage.length > 0
											? errorMessage
											: selectedSupplier
											? "Please click on Material Number to get the variance details"
											: "Please select the supplier to get all the materials assosciated with the selected supplier"}
									</span>
								)}
							</div>
						</div>
					</div>
				</MainContent>
			</div>
		</>
	);
};

const message = (
	<Notification type={"info"} header={`Exporting...`} closable>
		<p>
			Your file is being created. It will be download automatically.
			Please dont press back
		</p>
	</Notification>
);

const mapDispatchToProps = (dispatch: any) => ({
	onFilterChange: (data: any) => dispatch({ type: FILTERDATA, data: data }),
	onTimelineChange: (data: any) => dispatch({ type: TIMELINE, data: data }),
});
export default connect(null, mapDispatchToProps)(CostOptimization);
